module.exports = __webpack_public_path__ + "static/media/apex_ashare_lp.5ebfb267.png";